/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_5_TitleInputs */

const en_mk_cap_5_title = /** @type {(inputs: Mk_Cap_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachments the agent can read`)
};

const id_mk_cap_5_title = /** @type {(inputs: Mk_Cap_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lampiran yang ikut dibaca`)
};

/**
* | output |
* | --- |
* | "Attachments the agent can read" |
*
* @param {Mk_Cap_5_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_5_title = /** @type {((inputs?: Mk_Cap_5_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_5_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_5_title(inputs)
	return en_mk_cap_5_title(inputs)
});